import { ENCRYPTION_CONTENT_HEADER } from 'constants';

/**
 * @method doesStartWithContentHeader
 */
const doesStartWithContentHeader = (
  contentString,
  contentHeader = ENCRYPTION_CONTENT_HEADER,
) => {
  return contentString.trim().startsWith(contentHeader);
};

export default doesStartWithContentHeader;
